import { Languages } from '@framework/constants/enums/languages';

const useLanguages = () => {
    return [
        { name: 'English', value: Languages.English },
        { name: 'Deutsch', value: Languages.German },
        { name: 'Français', value: Languages.French },
        { name: 'Italiano', value: Languages.Italian },
        { name: 'Nederlands', value: Languages.Dutch },
        { name: 'Svenska', value: Languages.Swedish }
    ];
};

export default useLanguages;
